import { User } from 'fitify-types/src/types/user'
import { Segment } from 'fitify-ui-onboarding/src/components/Paywall/Segment/Segment'
import { UserResultCard } from 'fitify-ui-onboarding/src/components/Paywall/UserResultCard/UserResultCard'
import type {
  UserResultCardData,
  UseUserResultCardProps,
} from 'fitify-ui-onboarding/src/components/Paywall/UserResultCard/UserResultCard.Types'
import { useUserResultCard } from 'fitify-ui-onboarding/src/components/Paywall/UserResultCard/useUserResultCard'
import { useTranslation } from 'next-i18next/pages'
import { useMemo } from 'react'

import { useFunnel } from 'hooks/useFunnel'
import { getImageProps } from 'utils/images'
import { useDataState } from 'utils/state'

// TODO: Prefetch allUserData images

export const UserResults = () => {
  const { t } = useTranslation()
  const funnel = useFunnel()
  const { data } = useDataState()

  const gender = useMemo(() => {
    return data[funnel || 'shared'].gender
  }, [data, funnel])

  const allUserData = useMemo<UseUserResultCardProps>(() => {
    const female1 = {
      name: t('paywall_female_1_name'),
      result: t('paywall_female_1_weight_diff'),
      story: t('paywall_female_1_story'),
      imageProfile: getImageProps('shared', 'subscription', 'avatarFemale1'),
      imageAfter: getImageProps('shared', 'subscription', 'femaleRefAfter1'),
      imageBefore: getImageProps('shared', 'subscription', 'femaleRefBefore1'),
    } satisfies UserResultCardData
    const female2 = {
      name: t('paywall_female_2_name'),
      result: t('paywall_female_2_weight_diff'),
      story: t('paywall_female_2_story'),
      imageProfile: getImageProps('shared', 'subscription', 'avatarFemale2'),
      imageAfter: getImageProps('shared', 'subscription', 'femaleRefAfter2'),
      imageBefore: getImageProps('shared', 'subscription', 'femaleRefBefore2'),
    } satisfies UserResultCardData
    const male3 = {
      name: t('paywall_male_3_name'),
      result: t('paywall_male_3_weight_diff'),
      story: t('paywall_male_3_story'),
      imageProfile: getImageProps('shared', 'subscription', 'avatarMale3'),
      imageAfter: getImageProps('shared', 'subscription', 'maleRefAfter3'),
      imageBefore: getImageProps('shared', 'subscription', 'maleRefBefore3'),
    } satisfies UserResultCardData

    if (gender === User.Profile.Gender.Male) {
      return [
        {
          name: t('paywall_male_1_name'),
          result: t('paywall_male_1_weight_diff'),
          story: t('paywall_male_1_story'),
          imageProfile: getImageProps('shared', 'subscription', 'avatarMale1'),
          imageAfter: getImageProps('shared', 'subscription', 'maleRefAfter1'),
          imageBefore: getImageProps(
            'shared',
            'subscription',
            'maleRefBefore1'
          ),
        },
        {
          name: t('paywall_male_2_name'),
          result: t('paywall_male_2_weight_diff'),
          story: t('paywall_male_2_story'),
          imageProfile: getImageProps('shared', 'subscription', 'avatarMale2'),
          imageAfter: getImageProps('shared', 'subscription', 'maleRefAfter2'),
          imageBefore: getImageProps(
            'shared',
            'subscription',
            'maleRefBefore2'
          ),
        },
        male3,
      ]
    }
    if (gender === User.Profile.Gender.Female) {
      return [
        female1,
        female2,
        {
          name: t('paywall_female_3_name'),
          result: t('paywall_female_3_weight_diff'),
          story: t('paywall_female_3_story'),
          imageProfile: getImageProps(
            'shared',
            'subscription',
            'avatarFemale3'
          ),
          imageAfter: getImageProps(
            'shared',
            'subscription',
            'femaleRefAfter3'
          ),
          imageBefore: getImageProps(
            'shared',
            'subscription',
            'femaleRefBefore3'
          ),
        },
      ]
    }
    return [female1, female2, male3]
  }, [gender, t])

  const currentUserData = useUserResultCard(allUserData)

  return (
    <Segment title={t('paywall_user_meet_their_goals')}>
      <UserResultCard {...currentUserData} />
    </Segment>
  )
}
